import { ClientsTable } from "features/export/components/ClientsTable";
import { AuthenticatedLayout } from "features/common/components/AuthendicatedLayout";
import { InfoApp } from "features/app/components/InfoApp/InfoApp";

export const ClientExport = () => {
  return (
    <AuthenticatedLayout>
      <InfoApp />
      <ClientsTable />
    </AuthenticatedLayout>
  );
};
